import { delay, takeUntil, map, startWith } from 'rxjs/operators';
import { timer, interval, of } from 'rxjs';
export function waitUntilTimestamp(timestamp) {
    return of(null).pipe(delay(timestamp));
}
export function intervalUntilTimestamp(timestamp, intervalMilliseconds) {
    const stopAtTimestamp$ = timer(timestamp);
    return interval(intervalMilliseconds).pipe(startWith(millisecondsDiffFromNow(timestamp)), map(() => millisecondsDiffFromNow(timestamp)), takeUntil(stopAtTimestamp$));
}
export function millisecondsDiffFromNow(timestamp) {
    return timestamp.getTime() - Date.now();
}
